import { render } from "./AgeGateComponent.vue?vue&type=template&id=4f8f6620&scoped=true"
import script from "./AgeGateComponent.vue?vue&type=script&lang=js"
export * from "./AgeGateComponent.vue?vue&type=script&lang=js"

import "./AgeGateComponent.vue?vue&type=style&index=0&id=4f8f6620&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8f6620"]])

export default __exports__